import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {  Provider, useSelector } from 'react-redux'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import { createStore, combineReducers } from 'redux'
import { ReactReduxFirebaseProvider, firebaseReducer, isLoaded, isEmpty, useFirestoreConnect } from 'react-redux-firebase'
import { createFirestoreInstance, firestoreReducer } from 'redux-firestore'
import './App.scss';
import AuthRoute from './utils/AuthRoute';
import Loading from './components/Loading';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faLink, faCopy, faCheck } from '@fortawesome/free-solid-svg-icons'
import { Button, Jumbotron, Alert } from 'reactstrap';
import useFetch from 'fetch-suspense';
import {CarddassContext, UserContext} from './contexts';
import AllCarddassList from './pages/AllCarddassList';

library.add(fab, faLink, faCopy, faCheck);

// Firebase
const fbConfig = {
  apiKey: "AIzaSyBb20Yyr1cxy37DoXnh1yVSEXr1ZXpwyWk",  
  authDomain: "jccw-277700.firebaseapp.com",
  databaseURL: "https://jccw-277700.firebaseio.com",
  projectId: "jccw-277700",
  storageBucket: "jccw-277700.appspot.com",
  messagingSenderId: "184784088363",
  appId: "1:184784088363:web:acb8c0d6bd27c36d88e96e",
  measurementId: "G-BLHP994ZV3"
};
const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
};
if (!firebase.apps.length) firebase.initializeApp(fbConfig);
firebase.firestore();
firebase.app().functions('asia-northeast1');
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer 
});
const initialState = {};
const store = createStore(rootReducer, initialState);
const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
};

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./pages/Login'));
const Trade = React.lazy(() => import('./pages/Trade'));

// カードダス
function CarddassData({ children }) {
  const data = useFetch("https://asia-northeast1-jccw-277700.cloudfunctions.net/getCarddassDictionary");
  return(
    <CarddassContext.Provider value={data}>
      {children}
    </CarddassContext.Provider>
  );
}

// 認証
function AuthIsLoaded({ children }) {
  const auth = useSelector(state => state.firebase.auth)
  if (!isLoaded(auth)) return <Loading />;
  if (isLoaded(auth) && !isEmpty(auth) && auth.email.indexOf("@kofujc.com") < 0) {
    return (
      <Jumbotron>
        <Alert color="danger">ユーザー「{auth.email}」には、本システムを利用する権限がありません。ログアウトしてください。</Alert>
        <Button color="primary" onClick={()=> firebase.logout()}>ログアウト</Button>
      </Jumbotron>
    );  
  }
  return children;
}

function UserData({children}) {
  const auth = useSelector(state => state.firebase.auth)
  const userId = auth.email ? auth.email.split("@")[0] : "";
  useFirestoreConnect({collection:'users', doc:userId});
  const user = useSelector(({ firestore: { data } }) => data.users && data.users[userId]);
  if (!isLoaded(user)) return <Loading />;
  return(
    <UserContext.Provider value={{...user, id:userId}}>
      {children}
    </UserContext.Provider>
  );
}

class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <ReactReduxFirebaseProvider {...rrfProps}>
            <BrowserRouter>
                <React.Suspense fallback={<Loading />}>
                  <CarddassData>
                      <AuthIsLoaded>
                        <UserData>
                          <Switch>
                            <Route exact path="/login" name="ログイン" render={props => <Login {...props}/>} />
                            <Route exact path="/allcardlist" name="全カードリスト" render={props => <AllCarddassList {...props}/>} />
                            <AuthRoute exact path="/trade" name="カードを受け取る" render={props => <Trade {...props}/>} />
                            <AuthRoute path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
                          </Switch>
                        </UserData>
                      </AuthIsLoaded>
                  </CarddassData>
                </React.Suspense>
            </BrowserRouter>
        </ReactReduxFirebaseProvider>
      </Provider>
    );
  }
}

export default hot(App);
